import { render, staticRenderFns } from "./AdminUsefulLinks.vue?vue&type=template&id=250d4951&scoped=true"
import script from "./AdminUsefulLinks.vue?vue&type=script&lang=js"
export * from "./AdminUsefulLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250d4951",
  null
  
)

export default component.exports